import PARTNER from './partner.gql';

export {
  PARTNER,
};
